import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, User, LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login, isAuthed } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (isAuthed) navigate("/admin");
  }, [isAuthed, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username, password);
      navigate("/admin");
    } catch (err) {
      setError(err?.response?.data?.detail || "Login gagal. Periksa kembali kredensial Anda.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4"
      style={{ background: "linear-gradient(135deg, #044712 0%, #044712 60%, #198530 100%)" }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-white" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Panel Admin
          </h1>
          <p className="text-sm mt-1" style={{ color: "#bbf7d0" }}>Yayasan Wakaf Tongku Azhar Nahdliyyin</p>
        </div>
        <form onSubmit={handleSubmit} data-testid="admin-login-form"
          className="bg-white rounded-2xl shadow-2xl p-8 space-y-5">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">Username</label>
            <div className="relative">
              <User size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                data-testid="login-username"
                className="w-full pl-10 pr-4 py-2.5 rounded-xl border outline-none focus:ring-2"
                style={{ borderColor: "#dcfce7" }}
                placeholder="admin"
                required
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">Password</label>
            <div className="relative">
              <Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                className="w-full pl-10 pr-4 py-2.5 rounded-xl border outline-none focus:ring-2"
                style={{ borderColor: "#dcfce7" }}
                placeholder="••••••••"
                required
              />
            </div>
          </div>
          {error && <p className="text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2" data-testid="login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full flex items-center justify-center gap-2 text-white py-3 rounded-xl font-bold transition-all hover:opacity-90 disabled:opacity-60"
            style={{ backgroundColor: "#198530" }}
          >
            <LogIn size={18} /> {loading ? "Memproses..." : "Masuk"}
          </button>
          <a href="/" className="block text-center text-xs text-gray-400 hover:text-gray-600">← Kembali ke Beranda</a>
        </form>
      </div>
    </div>
  );
}
